if (!customElements.get('product-metafield-multi-tab')) {
  customElements.define(
    'product-metafield-multi-tab',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        $("body").on("click", ".product-metafield-multi-tab-head-item", function(){
          const indexTab = $(this).attr("data-tab");
          if(!indexTab) return;
          $(this).addClass("active").siblings().removeClass("active");
          $(`.product-metafield-multi-tab-body-item[data-tab="${indexTab}"]`).addClass("active").siblings().removeClass("active");
        })
      }
    }
  )
}

if (!customElements.get('product-metafield-multi-tab-item')) {
  customElements.define(
    'product-metafield-multi-tab-item',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        var swiper = new Swiper(".product-metafield-multi-tab-body-item > .swiper", {
          loop: true,
          autoplay: { 
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          // allowTouchMove: false,
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 15 },
            360: {
              slidesPerView: 2, 
              spaceBetween: 12,
            },
            767: {
              slidesPerView: 3, 
              spaceBetween: 13,
            },
            1024: {
              slidesPerView: 4, 
              spaceBetween: 14,
            },
          },
          navigation: {
            nextEl: ".product-metafield-multi-tab-body-item > .swiper > .swiper-button-next",
            prevEl: ".product-metafield-multi-tab-body-item > .swiper > .swiper-button-prev",
          },
          pagination: {
            el: ".product-metafield-multi-tab-body-item > .swiper > .swiper-pagination",
            clickable: true,	
            type: "fraction",
          },
        });
      }
    }
  )
}
